import React, { useState, useEffect } from 'react'
import { billingGetUserCards, billingDeleteCard } from './billingAccess'
import { isLoggedIn } from '../../common/ambient'
// import PropTypes from 'prop-types';
import { path } from 'ramda'
import bindUserActions from '../user/redux/bindUserActions'
import { Loader } from '../../components'

function DisplayCard ({ user, actions }) {
  const [fetching, setFetching] = useState(false)
  const [userCards, setUserCards] = useState(null)
  const defaultPaymentMethod = path(['info', 'payments', 'defaultPaymentMethod'], user)

  useEffect(() => {
    if (!isLoggedIn(user)) return
    if (fetching) return
    if (!defaultPaymentMethod) return
    const uc = path(['cards'], userCards)
    if (uc && uc.length === 0) return
    const theCard = (uc || []).find(card => card.id === defaultPaymentMethod)
    if (theCard) return

    async function wrapBillingGetUserCards () {
      setFetching(true)
      const userId = path(['info', '_id'], user)
      const success = await billingGetUserCards(userId, setUserCards)
      if (!success) {
        console.log('¯\\_(ツ)_/¯   billingGetUserCards failed')
        return // stay in fetching mode so we dont keep trying
      }
      setFetching(false)
    }
    wrapBillingGetUserCards()
  }, [user, fetching, userCards, defaultPaymentMethod])

  if (!defaultPaymentMethod) return null

  let brand = ''
  let exp_month = ''
  let exp_year = ''
  let last4 = ''
  let cardholderName = ''
  let hasCard = false

  if (userCards && userCards.cards && userCards.cards.length) {
    const theCard = userCards.cards[0]
    const { card } = theCard 
    if (card) {
      hasCard = true
      brand = path(['brand'], card)
      brand = brand ? brand.toUpperCase() : ''
      exp_month = path(['exp_month'], card)
      exp_year = path(['exp_year'], card)
      // Format year to 2 digits
      if (exp_year) {
        exp_year = String(exp_year).slice(-2)
      }
      // Pad month with leading zero if needed
      if (exp_month) {
        exp_month = String(exp_month).padStart(2, '0')
      }
      last4 = path(['last4'], card)
      cardholderName = path(['billing_details', 'name'], theCard) || ''
    }
  }

  async function delClicked (e) {
    e.preventDefault()
    if (!window.confirm("Your subscriptions will not renew if you don't have a card on file. Are you sure you want to delete this card?")) return
    const userId = path(['info', '_id'], user)
    const paymentId = path(['info', 'payments', 'defaultPaymentMethod'], user)
    if (!userId || !paymentId) return
    setFetching(true)
    const success = await billingDeleteCard(userId, paymentId)
    if (!success) {
      console.log('¯\\_(ツ)_/¯   billingDeleteCard failed')
    }
    delete user.info.payments.defaultPaymentMethod
    await actions.patch(user.info._id, { useSmsBankMetered: false })
    setFetching(false)
  }

  return (
    <div className='payment-display-card'>
      {cardholderName && (
        <div className='card-info-row'>
          <span className='label'>Cardholder</span>
          <span className='value'>{cardholderName}</span>
        </div>
      )}
      <div className='card-info-row'>
        <span className='label'>Card number</span>
        <span className='value'>
          **** **** **** {last4} <span className='brand'>{brand}</span>
        </span>
      </div>
      <div className='card-info-row'>
        <span className='label'>Expiring</span>
        <span className='value'>{exp_month}/{exp_year}</span>
      </div>
      {hasCard && (
        <div className='card-actions'>
          {fetching ? <Loader /> : <a onClick={delClicked} className='delete-link'>Delete card</a>}
        </div>
      )}
    </div>
  )
};

DisplayCard.propTypes = {}
DisplayCard.defaultProps = {}

export default bindUserActions(DisplayCard)

DisplayCard.displayName = 'DisplayCard'
